import React, { useState } from 'react';

export default function ShareModal({ shareText, gameUrl, onClose, onNewGame }) {
  const [copied, setCopied] = useState(false);

  function copy() {
    navigator.clipboard.writeText(shareText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  }

  const encText = encodeURIComponent(shareText);
  const encUrl  = encodeURIComponent(gameUrl);

  const BTNS = [
    { label: '𝕏',  bg: '#000',    href: `https://twitter.com/intent/tweet?text=${encText}` },
    { label: '💬', bg: '#25d366', href: `https://wa.me/?text=${encText}` },
    { label: 'f',  bg: '#1877f2', href: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}` },
    { label: 'in', bg: '#0a66c2', href: `https://www.linkedin.com/sharing/share-offsite/?url=${encUrl}` },
  ];

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: '1rem',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff', borderRadius: 18, padding: '1.2rem 1.3rem 1rem',
          maxWidth: 300, width: '100%', boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
          textAlign: 'center', position: 'relative',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Close ✕ */}
        <button onClick={onClose} style={{
          position: 'absolute', top: 10, right: 12,
          background: 'none', border: 'none', fontSize: '1.2rem',
          color: '#9ca3af', cursor: 'pointer', lineHeight: 1, padding: 0,
        }}>✕</button>

        <div style={{ fontWeight: 800, fontSize: '1rem', color: '#1e1b4b', marginBottom: '0.7rem', paddingRight: 16 }}>
          📤 Share Your Result
        </div>

        {/* Share text preview */}
        <div style={{
          background: '#f1f5f9', borderRadius: 10, padding: '0.55rem 0.75rem',
          fontSize: '0.72rem', color: '#475569', textAlign: 'left',
          marginBottom: '0.65rem', fontFamily: 'monospace', whiteSpace: 'pre-wrap',
          wordBreak: 'break-word', lineHeight: 1.6, maxHeight: 180, overflowY: 'auto',
        }}>
          {shareText}
        </div>

        {/* Copy */}
        <button onClick={copy} style={{
          width: '100%', borderRadius: 50, border: 'none', padding: '0.52rem',
          fontWeight: 700, fontFamily: 'Nunito, sans-serif', fontSize: '0.88rem',
          marginBottom: '0.5rem', cursor: 'pointer',
          background: copied ? '#10b981' : '#4f46e5', color: '#fff', transition: 'background 0.2s',
        }}>
          {copied ? '✓ Copied!' : '📋 Copy Result'}
        </button>

        {/* Social icons */}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: '0.75rem' }}>
          {BTNS.map(({ label, bg, href }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer"
              style={{
                width: 40, height: 40, borderRadius: '50%', background: bg,
                color: '#fff', textDecoration: 'none', fontWeight: 800, fontSize: '0.85rem',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
              {label}
            </a>
          ))}
        </div>

        {/* Actions */}
        <div className="d-flex gap-2 justify-content-center">
          {onNewGame && (
            <button onClick={() => { onNewGame(); onClose(); }} style={{
              borderRadius: 50, border: '1.5px solid #e2e8f0', background: 'none',
              padding: '0.38rem 1rem', fontWeight: 700, fontFamily: 'Nunito, sans-serif',
              fontSize: '0.82rem', cursor: 'pointer', color: '#374151',
            }}>🔄 New Game</button>
          )}
          <button onClick={onClose} style={{
            borderRadius: 50, border: 'none', background: '#f1f5f9',
            padding: '0.38rem 1rem', fontWeight: 700, fontFamily: 'Nunito, sans-serif',
            fontSize: '0.82rem', cursor: 'pointer', color: '#374151',
          }}>Close</button>
        </div>
      </div>
    </div>
  );
}
